import { RNG } from "rot-js";
import { ItemTypes } from "../../items/itemsTypes";
import { ShrineMap } from "../ShrineMap";

const depthBudget = [10, 20, 20, 20, 20];

type ItemKeyTyping = keyof typeof ItemTypes;
const depthWeights: Partial<{ [key in ItemKeyTyping]: number }>[] = [
  {
    shears: 10,
    knife: 5,
    spade: 5,
    mallet: 10,

    staff: 10,
    pitchfork: 10,
    scythe: 1,

    frock: 20,
    bCoat: 20,
    gambeson: 10,
    curiass: 1,

    buckler: 10,
    barricade: 1,
  },
  {
    shears: 5,
    spade: 1,
    knife: 10,
    cleaver: 5,
    mallet: 5,
    needle: 5,
    flail: 5,

    staff: 5,
    pitchfork: 5,
    scythe: 5,
    sledgehammer: 1,

    frock: 10,
    bCoat: 10,
    gambeson: 20,
    curiass: 10,
    bouilli: 2,

    buckler: 10,
    barricade: 5,
  },
  {
    shears: 1,
    knife: 1,
    cleaver: 10,
    mallet: 1,
    needle: 10,
    flail: 10,

    staff: 1,
    pitchfork: 1,
    scythe: 5,
    sledgehammer: 10,

    frock: 2,
    bCoat: 2,
    gambeson: 2,
    curiass: 20,
    bouilli: 20,

    buckler: 2,
    barricade: 20,
  },
  {
    shears: 1,
    knife: 1,
    cleaver: 10,
    mallet: 1,
    needle: 10,
    flail: 10,

    staff: 1,
    pitchfork: 1,
    scythe: 5,
    sledgehammer: 10,

    frock: 2,
    bCoat: 2,
    gambeson: 10,
    curiass: 20,
    bouilli: 20,

    buckler: 5,
    barricade: 10,
  },
  {
    shears: 1,
    knife: 1,
    cleaver: 10,
    mallet: 1,
    needle: 10,
    flail: 10,

    staff: 1,
    pitchfork: 1,
    scythe: 5,
    sledgehammer: 10,

    frock: 2,
    bCoat: 2,
    gambeson: 10,
    curiass: 20,
    bouilli: 20,

    buckler: 5,
    barricade: 10,
  },
];

export const generateLootTable = (rng: typeof RNG, map: ShrineMap) => {
  for (let i = 0; i < depthBudget[map.depth - 1] || 0; i++) {
    const itemType = rng.getWeightedValue(
      depthWeights[0] as any
    ) as ItemKeyTyping;
    if (itemType) {
      const cur = map.lootTable.get(itemType);
      map.lootTable.set(itemType, (cur || 0) + 1);
    }
  }
};
